import GeneralContainer from "../../../components/general/widgets/general";

const General = () => {
  return <GeneralContainer />;
};

export default General;
